import { ForemanDailySafetyItem } from './foreman-daily-safety-item.model';
import { ForemanEmployeeDispatch } from './foreman-employee-dispatch.model';
import { ForemanEquipmentDispatch } from './foreman-equipment-dispatch.model';
import { ForemanMaterialExpendable } from './foreman-material-expendable.model';
import { ForemanPhase } from './foreman-phase.model';
import { ForemanDailyTask } from './foreman-daily-task.model';
import { ForemanTask } from './foreman-task.model';
import { ForemanTimeSheet } from './foreman-time-sheet.model';
import { ForemanJobCrew } from './foreman-job-crew.model';
import { ForemanCustomerEquipment } from './foreman-customer-equipment.model';

export interface ForemanJobDetail {
  foremanJobID: string;
  jobID: string;
  vpJobID: string;
  name: string;
  workStatus: string;
  isActive: boolean;

  companyID: string;
  vpCompanyID: number;
  foremanJobStatusID: string;
  foremanJobStatusName: string;
  foremanJobStatusNote: string;
  foremanCustomerEquipmentID?: string;
  foremanCustomerEquipment?: ForemanCustomerEquipment;
  foremanCustomerEquipments?: ForemanCustomerEquipment[];
  /** Per-job Job Owner default (#30008); pre-selects the submission-sign dropdown. */
  jobOwnerHRRef?: number | null;
  jobOwnerName?: string | null;
  employeeCount: number;
  equipmentCount: number;
  employees: ForemanEmployeeDispatch[];
  equipment: ForemanEquipmentDispatch[];
  workOrders: ForemanPhase[];
  tasks: ForemanDailyTask[];
  materialExpendables: ForemanMaterialExpendable[];
  dailySafetyItems?: ForemanDailySafetyItem[];
  favoriteTasks?: ForemanTask[];
  classes?: string[];
  timeSheets?: ForemanTimeSheet[];
  foremanCrews?: ForemanJobCrew[];
  forceClearLocalData?: boolean;
  /**
   * True when this job is the employee's Viewpoint non-billable default
   * (bPREH.udNBJobNum). Set by Sparta on the job list so ITE can lock the panel
   * without a separate vp-api nbdefaultjob call (that route can lag deploy).
   */
  isNonBillableDefault?: boolean;
  /** bPREH.udNBPhase when isNonBillableDefault is true. */
  nonBillableDefaultPhase?: string | null;
  /** Convenience copy of the current shift's exceptions for PDF/submit. */
  exceptions?: string | null;
}
